"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redactEmailAddress = exports.trimPropertiesFromObject = exports.checkIfObject = exports.implicitFieldsToRemove = void 0;
const tslib_1 = require("tslib");
const lodash_isequal_1 = tslib_1.__importDefault(require("lodash.isequal"));
exports.implicitFieldsToRemove = [
    'password',
    'token',
    'email',
    'authorization'
];
const cyclicProperties = [];
const checkIfObject = (o) => typeof o === 'object' && !Array.isArray(o) && o !== null;
exports.checkIfObject = checkIfObject;
const trimPropertiesFromObject = (obj, properties = []) => {
    const checkIfObjectAlreadyChecked = (o) => cyclicProperties.find((p) => (0, lodash_isequal_1.default)(p, o));
    properties = [...properties, ...exports.implicitFieldsToRemove].map((p) => p.toLowerCase());
    if ((0, exports.checkIfObject)(obj) && Array.isArray(Object.keys(obj))) {
        Object.keys(obj).map((key) => {
            if (properties.includes(key.toLowerCase())) {
                delete obj[key];
            }
            else if ((0, exports.checkIfObject)(obj[key]) &&
                !checkIfObjectAlreadyChecked(obj[key])) {
                cyclicProperties.push(obj[key]);
                obj[key] = (0, exports.trimPropertiesFromObject)(obj[key], properties);
            }
        });
    }
    return obj;
};
exports.trimPropertiesFromObject = trimPropertiesFromObject;
const redactEmailAddress = (email = '') => {
    if (typeof email !== 'string' || email.length === 0) {
        return '';
    }
    if (!email.includes('@')) {
        // this is not an email, so return back the string
        return email;
    }
    const delimiter = '...';
    const emailSplit = email.split('@');
    let firstPart = emailSplit[0];
    if (firstPart.length >= 4) {
        firstPart =
            firstPart.substring(0, 2) +
                delimiter +
                firstPart.substring(firstPart.length - 2, firstPart.length);
    }
    return `${firstPart}@${emailSplit[1]}`;
};
exports.redactEmailAddress = redactEmailAddress;
//# sourceMappingURL=utils.js.map